import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import { ConfirmationModal } from "../components/ConfirmationModal";
import { deleteCookie } from "../context/CookiesContext";
import { useAuth } from "../hooks/useAuth";
import { refreshAccessToken } from "../services/AuthService";
import { deleteOrganization } from "../services/OrganizationService";
import queryClient, { useOrganizationGet } from "../state/QueryStore";
import { CustomAxiosError } from "../utilities/ErrorResponseHelper";

const DangerZonePage = () => {
  const [open, setOpen] = useState<boolean>(false);
  const { data: organization } = useOrganizationGet();
  const { user } = useAuth();
  if (!user || !user?.is_fairo_admin) {
    return <Navigate to="/organization" />;
  }

  const deleteMessage = `Are you sure you want delete ${organization?.name}? All data related to this organization will be deleted! \n
Organization ID: ${organization?.stytch_organization_id} \n
Organization slug: ${organization?.stytch_organization_slug}\n
  `;
  return (
    <Box paddingBottom="80px">
      <ConfirmationModal
        description={deleteMessage}
        onAccept={async () => {
          try {
            if (organization) {
              await deleteOrganization(organization.id);
              deleteCookie("organization_id");
              const tokens = await refreshAccessToken();
              queryClient.clear();
              if (tokens) {
                window.location.href = "/organization";
              }
            }
          } catch (error) {
            if (error instanceof CustomAxiosError) {
              error.showAuditLogSnackbar("Failed to create action");
            }
          }
        }}
        open={open}
        onClose={() => setOpen(false)}
        title="Delete organization"
        rejectText="Cancel"
        acceptText="Delete"
      />
      <Box display="flex" paddingTop="20px" flexDirection="column" gap="20px">
        <Typography variant="h3">Danger Zone</Typography>
        <Button
          fullWidth={false}
          sx={{
            maxWidth: "250px",
          }}
          color="error"
          onClick={() => setOpen(true)}
        >
          Delete Organization
        </Button>
      </Box>
    </Box>
  );
};

export default DangerZonePage;
